import { render, staticRenderFns } from "./CommunicationsTable.vue?vue&type=template&id=418ace2d&scoped=true"
import script from "./CommunicationsTable.vue?vue&type=script&lang=ts"
export * from "./CommunicationsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418ace2d",
  null
  
)

export default component.exports